import React from 'react';
import { Button, Tag } from 'antd';
import { getClassificationResult } from '../../../lib/util';
import { getInferenceStatus } from '../../../lib/util/status';
import { Model, InferenceFile } from '../../../types';
import { CustomLink } from '../../../components/CustomLink';

export const getDemoClassificationOverviewTableColumns = (
  onClickUrl: (data: InferenceFile) => any,
  onDelete: (data: InferenceFile) => any
) => {
  return [
    {
      title: 'Name',
      key: 'fileName',
      dataIndex: 'fileName',
      render: (text: string, record: InferenceFile) => (
        <span>
          <CustomLink disabled={record.status === 'PROCESSING'} onClickUrl={onClickUrl(record)}>
            {text}
          </CustomLink>
        </span>
      ),
    },
    {
      title: 'Model',
      key: 'model',
      dataIndex: 'model',
      render: (model: Model) => <span>{model && model.name}</span>,
    },
    {
      title: 'Class',
      key: 'class',
      render: (text: string, record: InferenceFile) => (
        <span>
          <Tag>{getClassificationResult(record) || 'Unknown'}</Tag>
        </span>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (text: string, record: InferenceFile) => (
        <span>
          <Tag color={getInferenceStatus(record).color}>{getInferenceStatus(record).label}</Tag>
        </span>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text: string, record: InferenceFile) => (
        <span>
          <Button type="link" onClick={() => onDelete(record)} style={{ marginLeft: '20px' }}>
            Delete
          </Button>
        </span>
      ),
    },
  ];
};
